/** @format */

function useLoginAuth() {
  let isUserLoggedIn = localStorage.getItem('USER_DETAILS');
  try {
    if (isUserLoggedIn === null) {
      throw new Error('User is not logged in.');
    }
    isUserLoggedIn = JSON.parse(isUserLoggedIn);
    if (
      !Object.hasOwn(isUserLoggedIn, 'client_id') ||
      !Object.hasOwn(isUserLoggedIn, 'domain_id')
    ) {
      throw new Error('User credentials are empty.');
    }
  } catch (e) {
    console.log(e.message);
    return false;
  }
  return true;
}

export { useLoginAuth };
